import { MODAL_EVENTS } from './modalEvents';

/** modal 实例上不可被 custom 覆盖的内置属性名 */
export const MODAL_BUILTIN_KEYS = [
  'visible',
  'data',
  'props',
  'options',
  'modalOptions',
  'modalPromise',
  'modal',
  'endModal',
  'cancelModal',
  ...MODAL_EVENTS,
] as const;

export type ModalBuiltinKey = typeof MODAL_BUILTIN_KEYS[number];

const MODAL_BUILTIN_KEY_SET = new Set<string>(MODAL_BUILTIN_KEYS);

/**
 * 判断键名是否为 modal 内置属性。
 * @param key - 待检查的键名
 * @returns 是否为内置属性
 */
function isModalBuiltinKey(key: string): key is ModalBuiltinKey {
  return MODAL_BUILTIN_KEY_SET.has(key);
}

export {
  MODAL_BUILTIN_KEY_SET,
  isModalBuiltinKey,
};
